// removed by extract-text-webpack-plugin
module.exports = {"root":"_25ByQ","section_miniClasses":"_2oh6Q"};


//////////////////
// WEBPACK FOOTER
// ./app/containers/Premium/Premium.scss
// module id = 1489
// module chunks = 3